//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';

export default {
  name: "ImageUpload",
  data() {
    return {
      value: this.initValue ? this.initValue : '',
    };
  },
  props: [ 
    'fieldName',
    'initValue',
    'dataWowAttr',
    'handleUploadImage'
  ],
  mounted(){

  },
  beforeDestroy() {
    
  },
  methods: {
    onSelectFile(e){
        $(this.$refs.input).trigger('click')
    },
    onRemoveFile(){
      this.$refs.input.value = ''
      this.value = ''
      const isRemoveImage = true;
      this.handleUploadImage(null, isRemoveImage)
    },
    onChange(e){
        if( !e.target.files[0] ){
          this.handleUploadImage(null)
          return
        }
        const reader = new FileReader()
        reader.onload = (e) => {
            this.value = e.target.result
        }
        reader.readAsDataURL(e.target.files[0])
        const file = e.target.files[0]
        this.handleUploadImage(file)
    }
  }
}
